export {
  getGraphemePinyinImageList,
  getGraphemePronunciationImageUrlPath,
} from "#grapheme-pinyin-image-assets";
